import axios from 'axios';

import { User } from 'admin/users/Users';

export interface SetPreferenceArgs {
    preferenceKey: string;
    preferenceValue: string;
}

export const setPreference = async (tenantId: number, userId: number, args: SetPreferenceArgs): Promise<User> => {
    const { data } = await axios.put<User>(`/api/tenants/${tenantId}/my-account/${userId}/set-preference`, { args });

    return data;
};

export interface SendInternalEmailArgs {
    subject: string;
    body: string;
    roleIds: string[];
}

export const sendInternalEmail = async (
    tenantId: number,
    userId: number,
    args: SendInternalEmailArgs,
): Promise<any> => {
    const { data } = await axios.put<User>(`/api/tenants/${tenantId}/my-account/${userId}/send-internal-email`, {
        args,
    });

    return data;
};
